import React from 'react';
import styled from 'styled-components/macro';

import { devices } from 'shared/css/devices';

import AuthPattern from './auth-pattern.png';

export const BackgroundStyled = styled.div`
  background-image: url(${AuthPattern});
  background-size: cover;
  bottom: 0;
  display: none;
  height: 35%;
  padding: 0;
  position: absolute;
  width: 100%;
  @media ${devices.tablet} {
    display: block;
  }
`;

export default ({ className }) => <BackgroundStyled className={className} />;
